export default class Slider {
	constructor(containerSelector, activeClass = 'is-active') {
		this.container = document.querySelector(containerSelector);

		if (!this.container) {
			return;
		}

		this.activeClass = activeClass;

		this.picture = this.container.querySelector('.Slider-picture');

		this.arrows = Array.prototype.slice.call(
			this.container.querySelectorAll('.Slider-arrow'),
		);

		this.steps = this.container.querySelector('.Slider-steps');

		this.attachEvents();
	}

	attachEvents() {
		this.arrows.forEach((arrow) => {
			arrow.addEventListener('click', () =>
				this.moveTo(
					arrow.classList.contains('Slider-arrow--prev') ? 'prev' : 'next',
				),
			);
		});

		window.addEventListener('hashchange', () => {
			const activePicture = this.picture.querySelector(`.${this.activeClass}`);
			const activeSlide = this.steps.querySelector(`.${this.activeClass}`);

			const nextPicture = this.picture.querySelector('.Slide');
			const nextSlide = this.steps.querySelector('.Slider-step');

			[activePicture, activeSlide].forEach((element) =>
				element.classList.remove(this.activeClass),
			);

			[nextPicture, nextSlide].forEach((element) =>
				element.classList.add(this.activeClass),
			);

			this.changeArrows(false, 'Slider-arrow--prev');
		});
	}

	moveTo(direction = 'next') {
		const activePicture = this.picture.querySelector(`.${this.activeClass}`);
		const activeSlide = this.steps.querySelector(`.${this.activeClass}`);

		const nextPicture =
			activePicture[
				direction === 'next' ? 'nextElementSibling' : 'previousElementSibling'
			];

		const nextSlide =
			activeSlide[
				direction === 'next' ? 'nextElementSibling' : 'previousElementSibling'
			];

		if (!nextSlide) {
			return;
		}

		this.changeArrows(
			nextSlide[
				direction === 'next' ? 'nextElementSibling' : 'previousElementSibling'
			],
			`Slider-arrow--${direction}`,
		);

		[activePicture, activeSlide].forEach((element) =>
			element.classList.remove(this.activeClass),
		);

		[nextPicture, nextSlide].forEach((element) =>
			element.classList.add(this.activeClass),
		);
	}

	changeArrows(isNextSlide, className) {
		this.arrows.forEach((arrow) => arrow.classList.remove('is-disabled'));

		if (!isNextSlide) {
			this.arrows.forEach((arrow) => {
				if (arrow.classList.contains(className)) {
					arrow.classList.add('is-disabled');
				}
			});
		}
	}
}
